/**
 * Build error codes that are known and may require special handling
 */
export enum BuildErrorCode {
	RepositoryClone = "ErrRepositoryClone",
	// Add other known error codes here as needed
	// BuildTimeout = "ErrBuildTimeout",
	// BuildCancelled = "ErrBuildCancelled",
}

/**
 * Set of error codes that should skip attempting to load build outputs from API
 * because the outputs don't exist or won't be available
 */
export const BUILD_ERRORS_SKIP_OUTPUT = new Set<string>([
	BuildErrorCode.RepositoryClone,
	// Add more error codes as needed
]);

/**
 * Determines if a build error code should skip loading build outputs
 * @param errorCode - The error code extracted from build status transitions
 * @returns true if outputs should not be loaded, false otherwise
 */
export function shouldSkipBuildOutputForError(errorCode: string | null): boolean {
	return errorCode !== null && BUILD_ERRORS_SKIP_OUTPUT.has(errorCode);
}
